export const COHORT_GROUP_RETRIEVE_MANY = 'COHORT_GROUP_RETRIEVE_MANY';
export const CREATE_COHORT_GROUP = 'CREATE_COHORT_GROUP';
export const DELETE_COHORT_GROUP = 'DELETE_COHORT_GROUP';
export const UPDATE_COHORT_GROUP = 'UPDATE_COHORT_GROUP';
export const UPDATE_COHORT_GROUP_ADMIN_ACCESS =
  'UPDATE_COHORT_GROUP_ADMIN_ACCESS';
export const FETCH_COHORT_GROUP_USERS_START = 'FETCH_COHORT_GROUP_USERS_START';
export const FETCH_COHORT_GROUP_USERS_SUCCESS =
  'FETCH_COHORT_GROUP_USERS_SUCCESS';
